import { defineMessages } from 'react-intl';

export default defineMessages({
    header: {
        id: 'app.components.Toast.header',
        defaultMessage: 'This is the Toast component !'
    },
    settingsHaveBeenSaved: {
        id: 'app.components.Toast.settingsHaveBeenSaved',
        defaultMessage: 'Preference settings have been saved'
    }
});



// WEBPACK FOOTER //
// ./app/components/toast/messages.js